import React, {useEffect, useState} from 'react';
import {Layout} from "antd";
import AppHeader from "./Header/AppHeader";
import {Outlet, useLocation} from "react-router-dom";
import AppSider from "./Sider/AppSider";
import AppFooter from "./Footer/AppFooter";

const AppLayout = () => {
    const { Content } = Layout;
    const [visible, setVisible] = useState(false);
    const location = useLocation().pathname;

    useEffect(() => {
        location === '/' || location === '/join' ? setVisible(false) : setVisible(true);
    }, [location]);

    return (
        <Layout style={{minHeight: '100vh'}}>
            {visible && <AppSider />}
            <Layout>
                {visible && <AppHeader />}
                <Content style={{padding: 15}}>
                    <Outlet />
                </Content>
            </Layout>
            <AppFooter />
        </Layout>
    );
};

export default AppLayout;